import Vue from 'vue';
const oldNextTick = Vue.nextTick;
function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);   // round up the min value
  max = Math.floor(max);  // round down the max value
  return Math.floor(Math.random() * (max - min + 1)) + min; // random int between min and max
}


export async function nextTick(callback:() => void):Promise<void>{
  if(getRandomInt(0,500)===0){
    await (new Promise((resolve,reject) => {
      console.log("timeout")
      setTimeout(resolve,0);
    }) )
    callback();
  }else{
    oldNextTick(callback);
  }
}